import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import "./GifSections.css";
import apiGETRequest from "../../../../../../../../utils/apiRequest";
import Button from "../../../../../../../Elements/Button";
import { debounce } from "../../../../../../../../hooks/utils";

const measureImage = (src) => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
  img.onerror = () => resolve(null);
  img.src = src;
});

const GifSection = ({ tool, handleSelectGifs, handleImageUpload, activeTab }) => {
  const [gifData, setGifData] = useState([]);
  const [search, setSearch] = useState("");
  const [isGif, setIsGif] = useState(false);
  const [loading, setLoading] = useState(false);
  const [gifDimensions, setGifDimensions] = useState({});
  const [buttonClicked, setButtonClicked] = useState(false)
  const inputRef = useRef(null);

  const handleGifChange = (status) => {
    setButtonClicked(true)
    setIsGif(status);
    setTimeout(() => inputRef.current?.focus(), 0);
  };

  const fetchGifsTenor = useCallback(
    debounce(async (searchQuery, isGifParam) => {
      try {
        setLoading(true);
        const gifList = await apiGETRequest(
          `editor/get-gifs/${searchQuery !== "" ? searchQuery : "excited"}/${isGifParam}`
        );
        setGifData(gifList?.data);
      } catch (error) {
        console.error("Error fetching gifs:", error);
      }
      setLoading(false);
      setTimeout(() => inputRef.current?.focus(), 0);
    }, 1000),
    []
  );

  const fetchImmediate = async (searchQuery, isGifParam) => {
    try {
      setLoading(true);
      const gifList = await apiGETRequest(
        `editor/get-gifs/${searchQuery !== "" ? searchQuery : "excited"}/${isGifParam}`
      );
      setGifData(gifList?.data);
    } catch (error) {
      console.error("Error fetching gifs:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchGifsTenor(search, isGif);
  }, [search, isGif, fetchGifsTenor]);

  useEffect(() => {
    if (!gifData.length) return;
    inputRef.current?.focus();
    setGifDimensions({});
    gifData.forEach((gif) => {
      measureImage(gif).then((dimensions) => {
        if (dimensions) setGifDimensions((prev) => ({ ...prev, [gif]: dimensions }));
      });
    });
  }, [gifData]);

  useLayoutEffect(() => {
    setTimeout(() => inputRef.current?.focus(), 0);
  }, []);

  useEffect(() => {
    setTimeout(() => inputRef.current?.focus(), 0);
  }, [activeTab]);

  return (
    <div className="GIFs-main">
      <div className="Gif-inp mb-2 d-flex justify-content-between align-items-center">
        <input
          ref={inputRef}
          placeholder="Search GIFs via GIPHY"
          onChange={(e) => setSearch(e?.target?.value)}
          value={search}
          className="center-placeholder"
        />
        <Button
          classList={!isGif ? 'primary' : "primary1"}
          text="Stickers"
          addonClass="px-2"
          onClick={() => handleGifChange(false)}
        />
        <Button
          classList={isGif ? 'primary' : "primary1"}
          text="GIFs"
          addonClass="px-2"
          onClick={() => handleGifChange(true)}
        />
      </div>
      {(!tool?.id || tool?.gif_type !== 'sticker' || (tool?.id && search?.length > 0) || buttonClicked) && gifData?.length > 0 ? (
        <div className="gifs-items">
          <div className="row flex-wrap gy-3">
            {loading ? (
              <div className="p-3">Loading....</div>
            ) : (
              gifData?.map((gif, index) => {
                const dimensions = gifDimensions[gif];
                return (
                  <div key={index} className="col-4">
                    <div
                      className="gif-item-wrapper"
                      onClick={async () => {
                        const resolvedDimensions = dimensions || await measureImage(gif);
                        handleSelectGifs("sticker", gif, resolvedDimensions);
                        setGifData([]);
                      }}
                    >
                      <img style={{ height: "160px", width: "160px" }} src={gif} alt="gif" />
                      {dimensions && (
                        <div className="gif-dim-label">{dimensions.width} × {dimensions.height}px</div>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
      {tool?.gif_type === "sticker" && tool?.value?.gif_link && (
        <div className="d-flex align-items-start gap-2 mt-2">
          <img
            src={tool?.value?.gif_link}
            alt="gif link"
            style={{ height: "160px", width: "160px", opacity: `${tool?.transparency ?? 10}` }}
          />
          <Button
            text={<><i className="fa-regular fa-trash-can me-1" />Remove Image</>}
            classList="danger-outline"
            addonClass="mt-1"
            onClick={(e) => { handleImageUpload(e, 'cancel'); fetchImmediate(search, isGif); }}
          />
        </div>
      )}
    </div>
  );
};

export default GifSection;
